import Axios from '../api/axios';
import * as glb from '../globals.js';
import { dispatchLookupUpdated, persistLookupCache } from './lookupStorage';
import { sortSabitLookup } from './sabitSort';

export const SABIT_LKP_EVENT = 'sabitLkpUpdated';

export function applyGlobalSabitLkp(sabitList, grupList) {
    glb.default.sabitLkp = sortSabitLookup(sabitList);
    glb.default.sabitgrupLkp = Array.isArray(grupList) ? grupList : [];
    persistLookupCache('sabitLkp', glb.default.sabitLkp);
    persistLookupCache('sabitgrupLkp', glb.default.sabitgrupLkp);
    dispatchLookupUpdated(SABIT_LKP_EVENT, {
        sabitCount: glb.default.sabitLkp.length,
        grupCount: glb.default.sabitgrupLkp.length,
    });
}

export function refreshGlobalSabitLkp() {
    return Promise.all([
        Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}SABIT/sabitlist`),
        Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}SABIT/sabitgrup`),
    ]).then(([sabitRes, grupRes]) => {
        applyGlobalSabitLkp(sabitRes?.data, grupRes?.data);
    });
}

export async function refreshGlobalSabitGrupLkp() {
    const grupRes = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}SABIT/sabitgrup`);
    glb.default.sabitgrupLkp = Array.isArray(grupRes?.data) ? grupRes.data : [];
    persistLookupCache('sabitgrupLkp', glb.default.sabitgrupLkp);
    dispatchLookupUpdated(SABIT_LKP_EVENT, { grupOnly: true });
    return glb.default.sabitgrupLkp;
}
